import { Breadcrumb, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Checkbox, DatePicker, message } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import PreviewImgModal from './PreviewImgModal';
import axios from 'axios';
const { Title, Paragraph, Text, Link } = Typography;
const { confirm } = Modal;
const { TextArea } = Input;
const AdminModal = ({
    editcard = {},
    setEditCard = () => { },
    handleEdit = () => { },
    handleSubmit = () => { },
    handleOk = () => { },
    edit = [],
    footer = [],
    children = [],
    title = '',
    open = false,
    setOpen = () => { },
    color = 'f09a45',
    uploads = true,
    cancel =()=>{}
}) => {
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    const [fileList, setFileList] = useState([]);
    const [more_pic, set_more_pic] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    useEffect(() => {
        if (JSON.stringify(editcard) != '{}') {
        } else {
            // props.setEditCard({ file_id: [], file_url: [] });
            setFileList([]);
            set_more_pic(true);
            // console.log(567);
        }
        set_more_pic(false)
        // console.log(props.editcard);
    }, [editcard])
    useEffect(() => {
        setFileList([]);
        let data_tmp = [];
        editcard?.file_id && editcard?.file_id.forEach((element, i) => {
            if (editcard?.file_url != undefined) {
                data_tmp.push({ uid: element, url: editcard?.file_url[i] })
            }
        })
        setFileList(data_tmp)

        // if (props.editcard['file_url']) {
        //     console.log(more_pic);

        //     console.log(data_tmp.length != 0, more_pic != true, data_tmp.length >= 2)
        //     if (data_tmp.length != 0 && more_pic != true && data_tmp.length >= 2) {
        //         console.log(123);
        //         data_tmp = data_tmp && data_tmp.slice(0, 2);
        //         set_more_pic(false);
        //     } else {
        //         console.log(345);
        //         set_more_pic(true);
        //     }
        //     console.log(data_tmp.length)
        // } else {
        //     get_picture(props.editcard['file_id']);
        //     console.log(123);
        // }

    }, [editcard])
    const get_picture = (data_tmp) => {
        data_tmp && data_tmp.map((value, index) => {
            // console.log(key, tmp);
            // tmp['file_id']
            axios
                .get('/officialWeb/backend/file', { responseType: 'blob', params: { "file_id": value } })
                .then((response) => {
                    var blob_ = new Blob([response.data], {
                        type: "image/jpg",// this is the only MIME for SVG

                    });
                    const dataurl = URL.createObjectURL(blob_);
                    setEditCard(
                        (pre) => {
                            if (pre.file_url != undefined) {
                                return (
                                    {
                                        ...pre,
                                        file_url: [...value.file_url, dataurl]
                                    }
                                )
                            } else {
                                return (
                                    {
                                        ...value,
                                        file_url: [dataurl]
                                    }
                                )
                            }

                        }
                    )
                    setFileList({ uid: value, url: dataurl })
                })
        })
    }
    // useEffect(() => {
    //     console.log(more_pic)
    // }, [more_pic])
    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append('inputFile', e);
        axios
            .post(`/officialWeb/backend/file`, form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                setFileList(
                    prev => {
                        return ([
                            ...prev,
                            {
                                uid: file_id,
                                url: dataurl
                            }
                        ])
                    }
                );
                // if (JSON.stringify(props.editcard) == '{}' || props.editcard.file_id == undefined) {
                //     props.setEditCard(
                //         pre => {
                //             return (
                //                 {
                //                     // file_id: [file_id],
                //                     file_url: [dataurl]
                //                 }
                //             )
                //         }
                //     )
                // } else {
                //     props.setEditCard(
                //         prev => {
                //             if (props.editcard.file_id.length == 0) {
                //                 return (
                //                     {
                //                         ...prev,
                //                         // file_id: [file_id],
                //                         file_url: [dataurl]

                //                     }
                //                 )
                //             } else {
                //                 return (
                //                     {
                //                         ...prev,
                //                         // file_id: [...prev.file_id, file_id],
                //                         file_url: [prev.file_url, dataurl]

                //                     }
                //                 )
                //             }
                //         }
                //     );
                // }
            })
    }

    const showConfirm = (e) => {
        confirm({
            title: '確認要刪除此張圖片嗎？',
            icon: <ExclamationCircleFilled />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (e) => {
        setImg(e.url);
        set_modal_img(true);
    }
    const remove = (e) => {
        setFileList(prev => prev.filter(filter_item => filter_item.uid !== e.uid));
    }
    // useEffect(() => {
    //     const keyDownHandler = event => {
    //         // console.log('User pressed: ', event.key);

    //         if (event.key === 'Enter') {
    //             event.preventDefault();

    //             // 👇️ call submit function here
    //             props.edit ? props.handleEdit(fileList.map(map_item => map_item.uid)) : props.handleSubmit(fileList.map(map_item => map_item.uid))
    //         }
    //     };

    //     document.addEventListener('keydown', keyDownHandler);

    //     return () => {
    //         document.removeEventListener('keydown', keyDownHandler);
    //     };
    // }, []);

    // useEffect(() => console.log(props), [props])
    return (
        <>
            {contextHolder}
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <Modal
                // width={'auto'}
                style={{ pointerEvents: 'auto' }}
                open={open}
                onOk={handleOk}
                bodyStyle={{ backgroundColor: edit ? '#faf6f5' : '#FCF5F6' }}
                width={450}
                footer={false}
                className="modalStyle2"
                wrapClassName={"modalStyle2"}
                modalRender={(e) => <>
                    <div style={{ backgroundColor: edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${color} 5px `, position: 'relative', height: '80vh' }}>
                        <Row gutter={[10, 10]} justify='center' style={{ minHeight: '65vh', maxHeight: '65vh', overflowY: 'scroll' }}>
                            <Col span={24} >
                                <Row gutter={[8, 8]} align={'middle'}>
                                    <Col span={24}>
                                        <Row justify="space-between" style={{ position: 'relative' }} align={'bottom'}>
                                            {edit ?
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/edit.png'></img>
                                                </> :
                                                <>
                                                    <img width="35%" height="35%" src='/cram_school/add.png'></img>
                                                </>}
                                            {title}
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        {children}
                                    </Col>
                                    <Col span={24} >
                                        {uploads && (<>
                                            <Row gutter={[8, 8]} align={'middle'}>
                                                <Col span={6}>上傳圖片</Col>
                                                <Col span={18}>
                                                    <Upload
                                                        accept="image/png,image/jpeg"
                                                        customRequest={handleUpload}
                                                        listType="picture-card"
                                                        fileList={fileList}
                                                        onPreview={handlePreview}
                                                        onRemove={e => showConfirm(e)}
                                                        // onChange={handleUpload} 
                                                        beforeUpload={false}
                                                        multiple
                                                    >
                                                        <div>
                                                            <PlusOutlined />
                                                            <div
                                                                style={{
                                                                    marginTop: 8,
                                                                }}
                                                            >
                                                                上傳圖片
                                                            </div>
                                                        </div>
                                                    </Upload>
                                                </Col>
                                                {/* <Col span={20}>
                                                    {more_pic == true ? null :
                                                        <Row align={'end'} >
                                                            <Col style={{ cursor: 'pointer', textDecoration: 'underline' }}>更多圖片</Col>
                                                        </Row>}
                                                </Col> */}
                                                <Col span={6}></Col>
                                                <Col span={18}>＊請注意圖片大小，限制在2MB以內</Col>
                                            </Row>
                                        </>)}
                                        {footer}
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={20} style={{ position: 'absolute', bottom: '3vh' }}>
                                <Row gutter={[10, 10]} justify={"center"}>
                                    <Col>
                                        <Button size='large' 
                                        style={{ background: '#4a4a4a', color: '#ffffff' }} 
                                        onClick={(e) => cancel()} block>取消</Button>
                                    </Col>
                                    <Col >
                                        <Button
                                            onClick={e => { edit ? handleEdit(fileList.map(map_item => map_item.uid)) : handleSubmit(fileList.map(map_item => map_item.uid)) }}
                                            size='large' style={{ background: edit ? `#${color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block
                                        >{edit ? '修改' : '送出'}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div >
                </>}
                centered
            >
            </Modal >
        </>
    )

}
export default AdminModal;